import { render, staticRenderFns } from "./IconLineFreeHand.vue?vue&type=template&id=0b99062f&"
import script from "./IconLineFreeHand.vue?vue&type=script&lang=js&"
export * from "./IconLineFreeHand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports